import type { ChartSeries, ValueFormatter } from '@/modules/analytics/hooks/useReportMetric';
import type { ReportMetricTableRow } from '@/modules/analytics/hooks/useReportMetricTable';
import type { MetricRange } from '@/shared/types/reports';

export const NAMED_PERIODS = [
  'week_to_date',
  'month_to_date',
  'last_month',
  'quarter_to_date',
  'last_quarter',
] as const;

export type NamedPeriod = (typeof NAMED_PERIODS)[number];

export const LEGACY_NAMED_PERIODS: Record<string, NamedPeriod> = { this_week: 'week_to_date' };

export type Period = { title_key: string; days?: number; single?: boolean; period?: NamedPeriod };

export type MetricExportEntry = {
  index: number;
  name: string;
  metricId?: string;
  range: MetricRange;
  series: ChartSeries[];
  groupColumns: string[];
  groupColumnLabels: Record<string, string>;
  breakdown: ReportMetricTableRow[];
  valueFormatter: ValueFormatter;
  hasData: boolean;
};
